// removed by extract-text-webpack-plugin
module.exports = {"materialize-textarea":"SettingsView__materialize-textarea___hPbFj","modal-2463794813":"SettingsView__modal-2463794813___ROXq2","container":"SettingsView__container___2er9H","profileContainer":"SettingsView__profileContainer___xZVaE","adaptContainer":"SettingsView__adaptContainer___2EQ45","emptyScreens":"SettingsView__emptyScreens___2KPFR","emptyImage":"SettingsView__emptyImage___25MYh","noDescFound":"SettingsView__noDescFound___3e7Bt"};


//////////////////
// WEBPACK FOOTER
// ./src/components/SettingsView/SettingsView.scss
// module id = 1533
// module chunks = 0